import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'bca-start-upload',
  templateUrl: 'start-upload.component.html',
  styleUrls: ['start-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StartUploadComponent {
  @Input()
  isUploading: boolean;
  @Output()
  fileSelected = new EventEmitter<File>();
  @Output()
  cancel = new EventEmitter<void>();

  hasFileSizeError: boolean;
  hasFileTypeError: boolean;

  onFileSelected({ target }: Event): void {
    const file = ((target as any).files as File[])[0];
    return file ? this.validateFile(file) : null;
  }

  validateFile(file: File): void {
    const { allowedImageMimeTypes, maxImageFilzeSizeMb } = environment.userData;
    const { fileSelected } = this;
    const fileSizeMb = file.size / 1024 / 1024;

    this.hasFileTypeError = !allowedImageMimeTypes.includes(file.type);
    this.hasFileSizeError = fileSizeMb > maxImageFilzeSizeMb;
    if (this.hasFileTypeError || this.hasFileSizeError) return;

    fileSelected.emit(file);
  }
}
